import React from "react";
import { Container } from "react-bootstrap";
import Common_Title from "../common_components/common_title/Common_Title";

const Terms_Conditions = () => {
  return (
    <section className="common_section">
      <Container>
        <div className="terms_header">
          <Common_Title darkText={"Terms And Conditions"} />
        </div>

        <div className="terms_content">
          <div className="terms_item">
            <h3 className="terms_head">1. TERMS OF USE</h3>
            <p className="terms_description">
              For the Terms of Use ("Terms") wherever the context may require,
              the terminology “We”/”Us”/”Our”/”Company” individually and
              collectively refer to as “Profcyma” and the terms “Visitor” “User”
              “You” refer to the users or any natural/legal person who has
              agreed to avail the Website products/services. “Services” shall
              include any Profcyma services offering certification courses of
              top universities, full-time degree courses in collaboration with
              the university, and corporate workshops.
            </p>
            <p className="terms_description">
              These Terms govern your visit to https://Profcyma.com ("Website").
              Please read the Terms carefully as they are updated on the
              Website from time to time. If you do not agree to these Terms,
              please exit the Website. Profcyma reserves the right to revise
              these Terms and Conditions at any time by updating this posting.
              You agree that such updates are binding obligations on all users
              of this Website. We request that you visit this page periodically
              to familiarize yourself with the Terms.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">2. ABOUT PROFCYMA</h3>
            <p className="terms_description">
              Profcyma is a dedicated skill-building and education consulting
              firm focused on distance and regular education since 2016. We
              provide management, executive programs, undergraduate &
              postgraduate courses, and short-term courses in collaboration
              with established universities and institutes. Our team combines
              young enthusiasts with industry veterans to deliver quality
              educational offerings.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">3. EDUCATIONAL PARTNERS &amp; ACCREDITATION</h3>
            <p className="terms_description">
              Profcyma is NOT a university but an education service provider
              offering Programs in consultation with Indian and International
              universities, educational institutions, governmental authorities,
              NGOs, corporates, etc. (each an "Educational Partner").
            </p>
            <p className="terms_description">
              Admission to a degree/diploma program of an Educational Partner
              is separate from being accepted into or taking one or more
              Programs offered via the Platform. Nothing in these Terms
              (including your use of the Platform or any Program) shall:
            </p>
            <ul className="terms_description">
              <li>
                (a) Enroll or register you in an Educational Partner, or any
                other school, division, institute or program of or associated
                with an Educational Partner; or
              </li>
              <li>
                (b) Allow you to access or use the resources or receive any
                benefits or privileges of an Educational Partner beyond the
                Programs.
              </li>
            </ul>
            <p className="terms_description">
              Any credential, acknowledgement, record, or award for a Program
              is determined solely by the Educational Partner (if offered) and
              may vary from Program to Program. You will not receive academic
              credit from any other Educational Partner for taking a Program
              unless such credit is directly awarded by that Educational
              Partner under its own policies and procedures.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">4. PAYMENT TERMS &amp; REFUND POLICY</h3>
            <p className="terms_description">
              To pay for any Program, you must have internet access and a
              current valid payment method as indicated during sign-up
              ("Payment Method"). Profcyma does not store credit card
              information restricted by the Reserve Bank of India (RBI) and
              uses third-party payment gateways. By using a third-party
              payment provider you agree to abide by that provider's terms.
            </p>
            <p className="terms_description">
              Profcyma is not responsible for any information that a third
              party may store; any loss incurred due to such storage is your
              responsibility. You agree to pay applicable fees and taxes based
              on billing information provided at enrolment. Failure to pay may
              result in withdrawal of access to a Program.
            </p>
            <p className="terms_description">
              Each Program has specific refund terms applicable on cancellation
              requests. Free trials last for the period specified during
              sign-up and may not be combined with certain offers.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">5. USE OF CONTENT ON THE WEBSITE</h3>
            <p className="terms_description">
              All logos, marks, brands, headings, labels, names, signatures,
              numerals, shapes, illustrations, or any combinations thereof
              appearing on this Website are the exclusive property of
              Profcyma unless otherwise noted. Use of Profcyma properties or
              any other content on this Website, except as provided in these
              Terms, is strictly prohibited.
            </p>
            <p className="terms_description">
              Content on this Website cannot be modified, reproduced,
              displayed, distributed, or otherwise used for any public or
              commercial purpose without our written consent.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">6. ACCEPTABLE WEBSITE USE</h3>
            <h4 className="terms_head">(A) Security Rules</h4>
            <p className="terms_description">
              We will protect your data per our Privacy Policy. You must not
              violate or attempt to breach the security of the Website. This
              includes but is not limited to:
            </p>
            <ul className="terms_description">
              <li>
                1. Accessing data not intended for you or logging into an
                account without authorization.
              </li>
              <li>
                2. Probing, scanning, or testing the vulnerability of the
                Company's systems or network.
              </li>
              <li>
                3. Interfering with Website Services provided to other users
                (e.g., submitting viruses, overloading, flooding, or
                crashing the Website).
              </li>
              <li>4. Sending unsolicited electronic mail or promotional spam.</li>
            </ul>
            <p className="terms_description">
              Violations may result in civil or criminal liability. If we
              suspect a breach of security or misuse, we may investigate and
              cooperate with law enforcement authorities.
            </p>

            <h4 className="terms_head">GENERAL RULES</h4>
            <p className="terms_description">
              You agree that the information you provide on the Website is
              true, accurate, complete, and up to date. You may not use the
              Website to transmit, distribute, store, or destroy material or
              data that:
            </p>
            <ul className="terms_description">
              <li>
                (a) Constitutes or promotes conduct that would be a criminal
                offense or violate any applicable law or regulation;
              </li>
              <li>
                (b) Infringes the copyright, trademark, trade secret, or other
                intellectual property rights of others or violates privacy or
                publicity rights;
              </li>
              <li>
                (c) Is libellous, defamatory, pornographic, profane, obscene,
                threatening, abusive, or hateful.
              </li>
            </ul>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">7. INTELLECTUAL PROPERTY RIGHTS</h3>
            <p className="terms_description">
              Unless otherwise indicated, Profcyma owns all Intellectual
              Property Rights to the Website, including copyrights, patents,
              trademarks, trade names, trade secrets, source code, databases,
              text, content, graphics, icons, and hyperlinks. You shall not
              use, reproduce, or distribute any content from the Website
              belonging to Profcyma without authorization.
            </p>
            <p className="terms_description">
              You shall not upload or post material protected by copyright or
              other proprietary rights without express permission from the
              owner. You are solely liable for any damages resulting from
              infringement or unlawful submissions.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">8. TRADEMARKS</h3>
            <p className="terms_description">
              The Website contains copyrighted material, trademarks, and other
              proprietary information. Profcyma owns copyrights in the
              selection, coordination, arrangement, and enhancement of content
              original to it. You may not modify, publish, transmit, create
              derivative works, or otherwise exploit any content for commercial
              purposes. Users may download/print copyrighted material for
              personal use only.
            </p>
            <p className="terms_description">
              Trademarks on the Website remain the exclusive property of
              Profcyma or the respective trademark owner and are not in the
              public domain unless explicitly stated.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">9. INTELLECTUAL PROPERTY RIGHTS COMPLAINTS</h3>
            <p className="terms_description">
              If you believe any work published on the Website infringes your
              intellectual property rights, please write to us at
              Profcyma101@gmail.com with details of the claimed infringement.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">10. INDEMNITY</h3>
            <p className="terms_description">
              You agree to defend, indemnify and hold harmless Profcyma, its
              officers, directors, employees, successors, permitted assigns,
              heirs, and agents from and against any costs, claims, actions,
              liabilities, demands, losses, and/or damages arising from your
              use of the Website or your breach of these Terms. This clause
              survives termination of the Terms.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">11. TERMINATION</h3>
            <p className="terms_description">
              These Terms are effective unless and until terminated by either
              you or Profcyma. You may terminate by discontinuing use of the
              Website. Profcyma may terminate immediately without notice and
              deny you access to the Website without liability. Upon
              termination, you must destroy all materials obtained from the
              Website and all copies thereof. Termination does not cancel any
              payment obligations or liabilities arising under the Terms.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">12. LIMITATION OF LIABILITY</h3>
            <p className="terms_description">
              To the maximum extent permitted by law, neither Profcyma nor
              its affiliates, directors, officers, or employees shall be
              liable for any direct, indirect, incidental, special,
              consequential, or exemplary damages arising from your use or
              inability to use the service, even if Profcyma has been advised
              of the possibility of such damages. The Website is provided on
              an "As Is" basis without warranties.
            </p>
            <p className="terms_description">
              In no event shall Profcyma's total liability to you exceed the
              amount paid by you to us, if any, related to the cause of
              action.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">13. DISCLAIMER OF CONSEQUENTIAL DAMAGES</h3>
            <p className="terms_description">
              Profcyma and associated parties shall not be liable for any
              incidental or consequential damages, lost profits, damage to
              computer hardware, loss of data, or business interruption
              resulting from use or inability to use the Website or Website
              materials.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">14. REVIEWS, FEEDBACK &amp; SUBMISSIONS</h3>
            <p className="terms_description">
              All reviews, comments, feedback, suggestions, ideas, and other
              submissions ("Comments") made by users to Profcyma shall be the
              exclusive property of Profcyma. By submitting Comments you
              assign all rights, titles, and interests (including copyright)
              in such Comments to Profcyma, which may use them commercially
              or otherwise without restriction.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">15. GOVERNING LAW &amp; JURISDICTION</h3>
            <p className="terms_description">
              These Terms shall be governed by the laws of India. The courts
              at Pune, India shall have exclusive jurisdiction over any
              disputes arising out of these Terms.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">16. FORCE MAJEURE</h3>
            <p className="terms_description">
              Profcyma shall not be liable for delays or failures caused by
              events beyond its control, including acts of God, war, strikes,
              floods, political events, technical failures, shortage of
              products, or extreme weather. In such cases Profcyma will use
              reasonable endeavours to perform obligations as soon as
              practicable.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">17. SUPERSEDE</h3>
            <p className="terms_description">
              Except where additional product/service specific terms apply,
              these Terms supersede all previous representations, understandings
              or agreements, written or oral.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">18. NOTICES</h3>
            <p className="terms_description">
              Unless expressly stated otherwise, all notices from you must be
              sent in writing to the registered address of Profcyma as shown
              in the "Contact Us" section of the Website.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">19. INVALIDITY &amp; SEVERABILITY</h3>
            <p className="terms_description">
              If any part of these Terms is held unenforceable or illegal, it
              shall be deemed invalid without affecting the enforceability of
              the remaining provisions. If any provision is invalid, unlawful
              or void, it shall be severable from these Terms.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">20. ENTIRE AGREEMENT</h3>
            <p className="terms_description">
              These Terms constitute the entire agreement between you and
              Profcyma regarding access to the Website, Services, and
              Products. Nothing in these Terms excludes or limits liability
              for fraud or fraudulent misrepresentation.
            </p>
          </div>

          <div className="terms_item">
            <h3 className="terms_head">21. COMMUNICATIONS AND MARKETING</h3>
            <p className="terms_description">
              We may use your information to respond to inquiries, provide
              customer support, send important information about services, and
              send marketing communications (with your consent) via SMS,
              Email, RCS, WhatsApp, and Voice.
            </p>
          </div>

        </div>
      </Container>
    </section>
  );
};

export default Terms_Conditions;
